module.exports = __webpack_public_path__ + "img/物联网平台在余热回收系统中的应用软件.028c179b.png";